export default "__VITE_ASSET__BvNINsof__"